export default function isWin(): boolean {
  return navigator.appVersion.indexOf('Win') !== -1;
}
